<template>
  <label class="toggle-switch">
    <input
      type="checkbox"
      :value="value"
      :name="name"
      @change="onChangeValue"
    />
  </label>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    hidden: {
      type: Boolean,
      required: false,
      default: null
    }
  },
  methods: {
    onChangeValue() {
      this.$emit('change-toggle-switch-value')
    }
  }
}
</script>
<style lang="scss" scoped>
.toggle-switch {
  margin: 3px 0px;
  display: flex;
  align-items: center;
  position: relative;
  width: 34px;
  height: 14px;
  border-radius: 7px;
  background-color: rgba($gray-1, 0.38);
  cursor: pointer;
  transition: background-color 0.4s;
}

.toggle-switch:has(:checked) {
  background-color: rgba($primary, 0.38);
}

.toggle-switch::after {
  position: absolute;
  left: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
  background: $gray-1;
  content: '';
  transition: left 0.4s;
}

.toggle-switch:has(:checked)::after {
  left: 20px;
  background: $primary;
}

.toggle-switch input {
  appearance: none;
}
</style>
